import React from 'react';
import { default as content } from '../content/en';

export default function Error({
    message,
    code = 500
})
{

  return (
    <>
    <div className="error-container">
      <div className="error-box">
        <h1 className="error-code">{code}</h1>
        <p className="error-message">{message}</p>
        <p>{content.error.noPaymentTaken}</p>
        <br />
        <p>{content.error.pleaseTryAgain}</p>
        <br />
        <p>{content.error.raiseSupportRequest}</p>
        <br />
        <button className="error-button" onClick={() => window.location.href = '/'}>
          {content.error.backToShop}
        </button>
      </div>
      <div className="error-footer">
        {content.error.needHelp} <a href="http://www.bikermobile.com/contact-us" style={{ color: '#ff6a00', textDecoration: 'none' }}>{content.error.contactSupport}</a>
      </div>
    </div>
    </>
  );
}